import { Tooltip } from 'react-tooltip';

const formatHours = (hours) => {
  const rounded = Math.round(hours * 100) / 100;
  return `${rounded} hrs`;
};

const OvertimeMark = ({ assignment, isPrint }) => {
  if (assignment?.is_auto_generated) {
    return null;
  }

  if (!assignment?.overtime_hours || assignment.overtime_hours <= 0) {
    return null;
  }

  const tooltipId = `overtime-tooltip-${assignment.id}`;

  return (
    <>
      <div className="overtime-mark" data-tooltip-id={tooltipId} />
      <Tooltip
        opacity={1}
        id={tooltipId}
        place="top"
        style={{ fontSize: 12, lineHeight: '12px', padding: '1px 1px' }}
        content={`Total: ${formatHours(assignment.overtime_total_hours)}`}
      />
    </>
  );
};

export default OvertimeMark;
